<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "add",
  data() {
    return {};
  },
  mounted() {
    window.addEventListener(
      "hashchange",
      () => {
        var currentPath = window.location.hash.slice(1); // 获取输入的路由
        if (this.$router.path !== currentPath) {
          this.$router.push(currentPath); // 动态跳转
        }
      },
      false
    );
  },

  metaInfo: {
    title: "Ekecash", // set a title
    meta: [
      {
        // set meta keyWords
        name: "keyWords",
        content:
          "préstamo,perú,crédito,efectivo,cash,dinero,depósito,urgente,credit,rápido",
      },
      {
        // set meta description
        name: "description",
        content:
          "Ekecash es una plataforma para préstamo seguro、préstamo en efectivo y préstamo de crédito personal sin hipoteca",
      },
    ],

    link: [
      {
        // set link
        rel: "asstes",
        href: "https://www.ekecash.pe/home",
      },
    ],
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
img {
  width: 100%;
  height: 100%;
  display: block;
}
p,
ul {
  margin: 0;
}
a {
  text-decoration: none;
  cursor: pointer;
}
.mainContent {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  position: relative;
}
</style>
